var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShield = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 37,
  fill: "none",
  preserveAspectRatio: "none",
  viewBox: "0 0 26 37"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.428 3.585 13 7.7l11.672-2.35L26 5.9v10.98q0 6.84-3.676 12.442T13 36.5q-3.605-1.005-6.405-3.652L13 29.301l-8.151 1.641a22 22 0 0 1-1.172-1.62Q0 23.72 0 16.88V5.9L13 .5z"
})));
export default SvgShield;